import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { NotificationProvider } from './context/NotificationContext';
import { AccountProvider } from './context/AccountContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const googleClientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
const queryClient = new QueryClient();

root.render(
  // StrictMode caused double get calls in development mode
  // It's recommended to keep the StrictMode on - https://chatgpt.com/share/67a09635-c098-800d-b903-031304ccec61
  <React.StrictMode>
  {/* <> */}
    <GoogleOAuthProvider clientId={googleClientId}>
      <CssBaseline /> {/* Apply baseline styles */}
      <NotificationProvider>
        <AuthProvider>
          <AccountProvider>
            <QueryClientProvider client={queryClient} >
              <App />
            </QueryClientProvider>
          </AccountProvider>
        </AuthProvider>
      </NotificationProvider>
    </GoogleOAuthProvider>
  {/* </> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
